import { API } from './API';

export class Email extends API {
  public id: number = -1;
  public email: string = '';
  public _destroy?: boolean = false;
}
